import {
  Component,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'app-login-layout',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './login-layout.template.html',
  styleUrls: [
    './login-layout.style.scss'
  ]
})
export class LoginLayoutComponent {
}
